<template>
  <div class="maps">
    <!-- <div class="title">中物数智云仓</div> -->
    <div class="heard">
      <span class="title1">{{ name }}</span>

      <div class="date">
        <div style="color: #03a8ab">全部（{{ quanbu }}）</div>
        <div style="color: #fff">正常（{{ zhengchang }}）</div>
        <div style="color: red">预出库（{{ yuchu }}）</div>
        <div>
          <el-button type="primary" size="mini" @click="goTo">返回</el-button>
        </div>

        <!-- <div>
          <div class="div">{{ shijian }}</div>
          <div class="span">PM</div>
        </div>
        <div>{{ nowDate + " " + nowWeek }}</div>-->
      </div>
    </div>
    <div class="content">
      <!-- 左侧车牌 -->
      <div class="left">
        <!-- <div class="chepaiTitle">出库单</div> -->
        <div class="chepaiInput">
          <el-input
            style="width: 330px"
            v-model="inputVlaue"
            placeholder="请输入车牌号进行查询"
            clearable
            @clear="clear"
          >
            <el-button
              style="padding-right: 10px"
              slot="suffix"
              type="text"
              @click="chaxun"
              >查询</el-button
            >
            <el-button
              style="padding-right: 10px"
              slot="suffix"
              type="text"
              @click="chongzhi"
              >重置</el-button
            >
          </el-input>
        </div>
        <div class="chepaiList">
          <div class="ul">
            <div
              class="li"
              :class="{ liActive: categoryIndex == index }"
              v-for="(item, index) in chukuList"
              :key="index"
              @click="chepaiClick(item, index)"
            >
              <div class="div1">
                <div style="color: #fff" class="iconBottom" slot="reference">
                  <i class="el-icon-lock" v-if="item.source == '1'"></i>

                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <i
                    class="el-icon-arrow-up"
                    v-if="item.down"
                    @click.stop="downClick(item, index)"
                  ></i>
                  <i
                    class="el-icon-arrow-down"
                    v-if="!item.down"
                    @click.stop="upClick(item, index)"
                  ></i>
                </div>

                <div style="color: #fdf449">
                  {{ item.outstockPlateNumber }}
                </div>
                <div style="color: #fdf449">
                  &nbsp;/&nbsp;{{ item.driverName }}
                </div>
                <div style="color: #fdf449">
                  &nbsp;/&nbsp;{{ item.productTypeName }}
                </div>
              </div>
              <div class="div1" style="color: #fdf449">
                {{ item.customerName }}
              </div>
              <div
                class="xiangqingFlag"
                v-for="(item1, index1) in item.chepaiXQ"
                :key="index1"
              >
                <div style="color: #fff">
                  {{ item1.cargoBarcode }}
                </div>
                <div class="top">
                  <div class="bot1" style="color: #fff">
                    {{ item1.warehouseName }}-{{ item1.locationName }}-{{
                      item1.binName
                    }}
                  </div>
                  <div
                    class="bot"
                    :style="{
                      color:
                        item1.outstockCheckName == '已查验' ? 'red' : '#61FF10',
                    }"
                  >
                    {{ item1.outstockCheckName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center"></div>
      <div class="right" id="right" ref="pageContainer">
        <div
          v-if="heightFlag"
          class="divCenter"
          id="divCenter"
          :style="{
            width: width + 'px',
            height: height + 'px',
            border: '1px solid #ccc',
            borderTop: '10px solid #F1AB4B',
            borderBottom: '10px solid #F1AB4B',
          }"
        >
          <div class="biankuang" id="biankuang">
            <template v-for="(item, index) in quweiList">
              <div
                :style="{
                  height: (item.rightY - item.leftY) * item.w + 'px',
                  lineHeight: (item.rightY - item.leftY) * item.w + 'px',
                }"
              >
                {{ item.locationName }}
              </div>
            </template>
          </div>
          <div
            class="gangjuan"
            id="gangjuan"
            v-for="(item, index) in gangjuanList"
          >
            <div
              :style="{
                left: item.coordinateX * item.w + 'px',
                top: item.coordinateY * item.w + 'px',
              }"
              :class="[item.state == 0 ? 'b1' : 'active']"
              @click="juanClick(item)"
            ></div>
          </div>
          <!-- 天车 --><!-- 上圆 --><!-- 中间 --><!-- 下圆 -->
          <!-- <div class="tianche" id="tianche">

            <div class="circle1"></div>

            <div class="circle2" id="circle2" @click.stop="tiancheClick"></div>

            <div class="circle3"></div>
          </div>-->
        </div>
        <!-- 反 -->
        <div
          v-if="!heightFlag"
          class="divCenter1"
          id="divCenter"
          :style="{
            width: width + 'px',
            height: height + 'px',
            border: '1px solid #ccc',
            borderLeft: '10px solid #F1AB4B',
            borderRight: '10px solid #F1AB4B',
          }"
        >
          <div class="biankuang" id="biankuang">
            <template v-for="(item, index) in quweiList">
              <div
                :style="{
                  width: (item.rightY - item.leftY) * item.w + 'px',
                }"
              >
                {{ item.locationName }}
              </div>
            </template>
          </div>
          <div
            class="gangjuan"
            id="gangjuan"
            v-for="(item, index) in gangjuanList"
          >
            <div
              :style="{
                left: item.coordinateY * item.w + 'px',
                top: item.coordinateX * item.w + 'px',
              }"
              :class="[item.state == 0 ? 'b1' : 'active']"
              @click="juanClick(item)"
            ></div>
          </div>
          <!-- 天车 --> <!-- 上圆 --><!-- 中间 --><!-- 下圆 -->
          <!-- <div class="tianche" id="tianche">

            <div class="circle1"></div>

            <div class="circle2" id="circle2" @click.stop="tiancheClick"></div>

            <div class="circle3"></div>
          </div> -->
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        title="请输入验单密码"
        :visible.sync="yandanMark"
        width="30%"
        :before-close="handleClose"
      >
        <span>
          <div class="billNo">出库单号：{{ this.billNo }}</div>
          <el-input
            v-model="yandanInput"
            placeholder="请输入验单密码"
          ></el-input>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="yandanNo">取 消</el-button>
          <el-button type="primary" @click="yandanOk">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'

import { findPositionForAI } from '@/api/wms-stock'
import {
  fidListOutstockMasterForAi,
  // positionTianChe,
  fidListOutstockDetail,
  getCargoCoordinateListForWhId,
  unlockWhOutstockMaster
} from '@/api/wms-access'
import dateFormat from '../../../utils/Date'

export default {
  data () {
    return {
      quanbu: 0,
      zhengchang: 0,
      yuchu: 0,
      heightFlag: false,
      yandanMark: false,
      down: false,
      up: true,
      chepaiXQFlag: false,
      xiangqingFlag: false,
      yandanInput: '',
      billNo: '',
      outstockId: '',
      widthox: '230px',
      categoryIndex: null,
      width: '',
      height: '',
      widthLength: '0px',
      chepaiInput: '',
      inputVlaue: '',
      number: 0, // 仓库id
      id: '', // 仓库id
      name: '', // 仓库id
      xinxi: '', // 仓库id
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      shijian: '', // 当前时间
      nowWeek: '', // 当前星期
      equipmentTag: '', // 出库主列表
      x: '', // 出库主列表
      y: '', // 出库主列表
      z: '', // 出库主列表
      w: '', // 出库主列表
      tiancheList: [], // 区位主列表
      quweiList: [], // 区位主列表
      gangjuanList: [], // 钢卷主列表
      chukuList: [], // 出库主列表
      chepaiXQ: [], // 车牌详情
      xianshiList: [], // 车牌详情
      chukuXQList: [] // 出库详情列表
    }
  },
  computed: {
    classOption () {
      return {
        // step: 0.005,
        step: 0.015,
        // step: 0.3,
        limitMoveNum: 1, // 这个是修改moveSwitch()之前的使用方法，这里的数值指的是数据条数
        // limitMoveNum: this.churutableData.length,
        openTouch: false,
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  filters: {
    formatDate (time) {
      let date = new Date(time)
      return dateFormat.formatDate(date, 'MM.dd hh:mm')
    },
    formatDate1 (time) {
      let date = new Date(time)
      return dateFormat.formatDate(date, 'yyyy.MM.dd hh:mm')
    }
  },
  created () {
    this.id = this.$route.query.id // 接受参数关键代码
    this.name = this.$route.query.name // 接受参数关键代码
    this.x = this.$route.query.x // 接受参数关键代码10000
    this.y = this.$route.query.y // 接受参数关键代码5000
    this.z = this.$route.query.z // 接受参数关键代码
    this.equipmentTag = this.$route.query.equipmentTag // 接受参数关键代码
    this.width = ''
    this.height = ''
    this.w = ''

    // 宽度<高度=反向显示
    this.$nextTick(() => {
      this.w = (
        parseInt(this.$refs.pageContainer.offsetHeight) / parseInt(this.y)
      ).toFixed(2)
      this.width = parseInt(this.x * this.w)
      this.height = this.$refs.pageContainer.offsetHeight
      if (this.height > this.width) {
        this.$nextTick(() => {
          this.w = (
            parseInt(this.$refs.pageContainer.offsetWidth) / parseInt(this.y)
          ).toFixed(2)
          this.width = this.$refs.pageContainer.offsetWidth
          this.height = parseInt(this.x * this.w)
        })
        // 宽度>高度=正常显示
      } else {
        this.heightFlag = true
      }
    })

    // this.timer = setInterval(() => {
    //   this.positionTianCheS()
    // }, 3000)
    // this.positionTianCheS()
    this.getCargoCoordinateListForWhIdS()
    this.findPositionForAIS()
    this.fidListOutstockMasterForAiS()
  },
  destroyed () {
    if (this.timer) {
      // 注意在vue实例销毁前，清除我们的定时器
      clearInterval(this.timer)
    }
  },
  methods: {
    // 点击进仓
    goTo () {
      this.$router.push({
        path: '/cangWeiDefend'
      })
    },
    animate (x, y) {
      if (this.heightFlag) {
        var box = document.getElementById('tianche')
        var circle2 = document.getElementById('circle2')
        box.style.left = x * this.w + 'px'
        circle2.style.top = y * this.w + 'px'
      } else {
        var box1 = document.getElementById('tianche')
        var circle21 = document.getElementById('circle2')
        box1.style.left = 0 + 'px'
        circle21.style.top = -7.5 + 'px'

        box1.style.top = x * this.w + 'px'
        // circle21.style.top = x * this.w + 'px'
        circle21.style.left = y * this.w + 'px'
      }
    },
    upClick (item, index) {
      fidListOutstockDetail({
        outstockId: item.outstockId
      })
        .then((res) => {
          this.chepaiXQ = []
          this.chepaiXQ = res
          this.chukuList[index].down = true
          this.chukuList[index].chepaiXQ = []
          // this.$set(this.chukuList[index], 'chepaiXQ', this.chepaiXQ)
          this.chukuList[index].chepaiXQ = this.chepaiXQ
          if (this.chukuList[index].chepaiXQ.length !== 0) {
            this.chukuList[index].down = true
          } else {
            this.chukuList[index].down = false
          }
          this.$forceUpdate()
          this.gangjuanList.forEach((item1, index1) => {
            item1.state = 0
          })
          this.gangjuanList.forEach((item, index) => {
            this.chepaiXQ.forEach((item1, index1) => {
              if (item1.cargoBarcode == item.cargoBarcode) {
                item.state = 1
              }
            })
          })
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 点击下按钮
    downClick (item, index) {
      fidListOutstockDetail({
        outstockId: item.outstockId
      })
        .then((res) => {
          this.chepaiXQ = []
          this.chepaiXQ = res
          this.chukuList[index].down = false
          this.chukuList[index].chepaiXQ = []
          if (this.chukuList[index].chepaiXQ.length !== 0) {
            this.chukuList[index].down = true
          } else {
            this.chukuList[index].down = false
          }
          this.$forceUpdate()
          this.gangjuanList.forEach((item1, index1) => {
            item1.state = 0
          })
          this.gangjuanList.forEach((item, index) => {
            this.chepaiXQ.forEach((item1, index1) => {
              if (item1.cargoBarcode == item.cargoBarcode) {
                item.state = 1
              }
            })
          })
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },

    handleClose () {
      this.yandanMark = false
    },
    // 验单取消+验单确定
    yandanNo () {
      this.yandanInput = ''
      this.yandanMark = false
    },
    yandanOk () {
      // 验单
      unlockWhOutstockMaster({
        outstockId: this.outstockId, // 出库主表id
        password: this.yandanInput // 验单密码
      })
        .then((res) => {
          this.yandanMark = true
          this.fidListOutstockDetailS(this.outstockId)
          DonMessage.success('验单成功！')
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击车牌号
    chepaiClick (item, index) {
      this.outstockId = item.outstockId
      this.billNo = item.outstockNo
      this.categoryIndex = index
      if (item.source == '1') {
        // 货主端显示验单按钮
        this.yandanInput = ''
        this.yandanMark = true
      } else {
        this.fidListOutstockDetailS(this.outstockId) // 获取详细信息
      }
    },

    // 点击
    juanClick (item) {
      console.log(item)
      this.$router.push({
        path: '/wms/logisticsDisplay',
        query: {
          id: this.id,
          name: this.name,
          equipmentTag: this.equipmentTag,
          cargoNumber: this.cargoNumber,
          positionX: this.tiancheList.positionX,
          positionY: this.tiancheList.positionY,
          x: this.x,
          y: this.y
        }
      })
    },
    // 点击查询
    chaxun () {
      // this.animate()
      this.fidListOutstockMasterForAiS()
    },
    // 点击重置
    chongzhi () {
      this.inputVlaue = ''
      this.fidListOutstockMasterForAiS()
      this.getCargoCoordinateListForWhIdS()
    },
    // 点击出入库清空
    clear () {
      this.inputVlaue = ''
      this.fidListOutstockMasterForAiS()
      this.getCargoCoordinateListForWhIdS()
    },
    // 点击天车
    tiancheClick () {
      // this.$router.push({ path: '/wms/logisticsDisplay' })
      this.$router.push({
        path: '/wms/logisticsDisplay',
        query: {
          id: this.id,
          name: this.name,
          equipmentTag: this.equipmentTag,
          cargoNumber: this.cargoNumber,
          positionX: this.tiancheList.positionX,
          positionY: this.tiancheList.positionY,
          x: this.x,
          y: this.y
        }
      })
    },

    // 区位信息
    findPositionForAIS () {
      findPositionForAI({
        warehouseId: this.id
      })
        .then((res) => {
          this.quweiList = res
          this.quweiList.forEach((item, index) => {
            item.w = this.w
          })
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 车牌里面详细信息
    fidListOutstockDetailS (id) {
      fidListOutstockDetail({
        outstockId: id
      })
        .then((res) => {
          this.chepaiXQ = []
          this.chepaiXQ = res
          this.gangjuanList.forEach((item1, index1) => {
            item1.state = 0
          })
          this.gangjuanList.forEach((item, index) => {
            this.chepaiXQ.forEach((item1, index1) => {
              if (item1.cargoBarcode == item.cargoBarcode) {
                item.state = 1
              }
            })
          })
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 出库货物信息主数据-钢卷
    getCargoCoordinateListForWhIdS () {
      getCargoCoordinateListForWhId({
        warehouseId: this.id
      })
        .then((res) => {
          this.gangjuanList = res
          this.gangjuanList.forEach((item, index) => {
            item.w = this.w
          })
          this.quanbu = res.length
          this.zhengchang = 0
          this.yuchu = 0
          this.gangjuanList.forEach((item1, index1) => {
            if (item1.state == 0) {
              this.zhengchang++
            } else if (item1.state == 1) {
              this.yuchu++
            }
          })
          //     quanbu: '',
          // zhengchang: '',
          // yuchu: '',
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 出库列表主数据
    fidListOutstockMasterForAiS () {
      fidListOutstockMasterForAi({
        outstockPlateNumber: this.inputVlaue,
        warehouseId: this.id
      })
        .then((res) => {
          this.chukuList = res
          // chepaiXQ、
          if (this.chukuList.length <= 1) {
            this.categoryIndex = 0
          } else {
            this.categoryIndex = null
          }
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 天车
    // positionTianCheS () {
    //   positionTianChe({
    //     // outstockPlateNumber: this.inputVlaue,
    //     equipmentTag: this.equipmentTag
    //   })
    //     .then((res) => {
    //       this.tiancheList = res
    //       console.log(this.tiancheList, 'this.tiancheList')
    //       // // chepaiXQ、
    //       this.animate(this.tiancheList.positionX, this.tiancheList.positionY)
    //     })
    //     .catch((err) => {
    //       // DonMessage.error(err.message);
    //       console.log(err)
    //     })
    // },
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      hh = hh < 10 ? '0' + hh : hh
      let ff = new Date().getMinutes()
      ff = ff < 10 ? '0' + ff : ff
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '年' + mm + '月' + dd + '日'
      _this.shijian = hh + ':' + ff
    }
  }
}
</script>
<style lang="scss" scoped>
.heard {
  width: 100%;
  height: 6vh;
  display: flex;
  // background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  // text-align: center;
  position: relative;
  .title1 {
    // flex: 1;
    height: 6vh;

    line-height: 6vh;
    font-size: 30px;
    // font-weight: 700;
    color: #03faec;
    position: absolute;
    left: 30px;
  }
  .date {
    height: 6vh;

    line-height: 6vh;
    font-size: 14px;
    width: 400px;
    color: #ffdd17;
    display: flex;
    position: absolute;
    right: 20px;

    div {
      flex: 1;
    }
  }
}
.el-collapse-item__header {
}
.maps {
  position: relative;
  height: 100vh;
  // height: 100%;
  width: 100%;
  background: url("../../../assets/cangku/bg.png") no-repeat;
  overflow: hidden;
  // 头部
  .title {
    // height: 10vh;
    // text-align: center;
    // line-height: 10vh;
    width: 100%;
    color: #02faec;
    font-size: 30px;
    flex-wrap: 700;
  }
  .billNo {
    font-size: 25px;
    height: 5vh;
    line-height: 5vh;
    flex-wrap: 700;
    margin-bottom: 20px;
  }
  .content {
    height: 90vh;
    background-size: 100% 100%;
    display: flex;
    // flex-direction: column;
    // background-color: pink;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    // border: 1px solid #03F6E2;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;
    .left {
      width: 19%;
      height: 100%;
      border: 1px solid #ccc;
      padding-left: 10px;
      box-sizing: border-box;

      .chepaiTitle {
        height: 4vh;
        line-height: 4vh;
        width: 100%;
        color: #03f6e2;
        font-weight: 700;
        font-size: 20px;
      }
      .chepaiInput {
        height: 5vh;
        line-height: 5vh;
        display: flex;
        margin-top: 10px;
      }
      .chepaiList {
        margin-top: 10px;

        height: 75vh;
        margin-right: 11px;

        overflow-y: scroll;
        .ul {
          display: flex;
          flex-direction: column;
          .liActive {
            // height: 10vh;
            border-radius: 2px;
            background-color: #354165;
            display: flex;
            flex-direction: column;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            border: 1px solid #03f6e2;
            .div1 {
              height: 4vh;
              line-height: 4vh;
              text-align: center;
              // display: flex;
            }
          }
          .xiangqingFlag {
            background-color: #354165;
            border-bottom: 1px dashed #ccc;
            color: #13c5f8;
            width: 100%;
            position: relative;
            text-align: left;
            font-size: 14px;
            .top {
              display: flex;
            }
            .bot {
              position: absolute;
              right: 10px;
            }
            .bot1 {
              // position: absolute;
              // right: 70px;
              color: rgb(3, 246, 226);
            }
          }
          .li {
            // height: 10vh;
            border-radius: 2px;
            background-color: #354165;
            display: flex;
            flex-direction: column;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            position: relative;
            .iconBottom {
              position: absolute;
              right: 20px;
              top: 20px;
            }
            .div1 {
              height: 4vh;
              line-height: 4vh;
              text-align: center;
              display: flex;
            }
          }
        }
      }
    }
    .center {
      width: 1%;
      height: 100%;
    }
    .right {
      width: 80%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .divCenter {
        position: relative;
        // display: flex;
        // flex-direction: column;
        border: 1px solid #fff;
        overflow-y: scroll;
        background: url("../../../assets/znc/大bg.png") no-repeat;

        .biankuang {
          width: 100%;
          position: absolute;
          left: 0;
          display: flex;
          flex-direction: column;
          color: rgb(233, 213, 36);
          font-weight: 700;
          // border-bottom: 1px dashed #ccc;
          z-index: 3333;
          font-size: 14px;
          div {
            width: 100%;

            border-bottom: 1px dashed #ccc;
            z-index: 3333;
          }
        }
        .gangjuan {
          position: absolute;
          left: 0;
          width: 100%;
          height: 100%;

          // background-color: pink;
          .b1 {
            position: absolute;
            left: 0;
            top: 0;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: #fff;
            z-index: 3333;
          }
          .active {
            position: absolute;
            left: 0;
            top: 0;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: red;
          }
        }
        .tianche {
          height: 100%;
          width: 2px;
          background-color: rgb(60, 206, 243);
          position: absolute;
          left: 20px;
          z-index: 4444;

          .circle1 {
            width: 20px;
            height: 10px;
            border-radius: 10px 10px 0 0;
            line-height: 10px;
            position: absolute;
            bottom: 0;
            left: -10px;
            background-color: rgb(60, 206, 243);
          }
          .circle2 {
            width: 15px;
            height: 25px;
            background-color: rgb(248, 231, 76);
            position: absolute;
            top: 20px;
            left: -7.5px;
            border-radius: 5px;
          }
          .circle3 {
            width: 20px;
            height: 10px;
            border-radius: 0 0px 10px 10px;
            line-height: 10px;
            position: absolute;
            top: 0;
            left: -10px;

            background-color: rgb(60, 206, 243);
          }
        }
      }
      .divCenter1 {
        position: relative;
        overflow: hidden;
        background: url("../../../assets/znc/大bg.png") no-repeat;

        .biankuang {
          height: 100%;
          position: absolute;
          left: 0;
          display: flex;
          color: rgb(233, 213, 36);
          font-weight: 700;
          z-index: 3333;
          font-size: 14px;
          div {
            width: 100%;
            border-right: 1px dashed #ccc;
            z-index: 3333;
            writing-mode: vertical-lr;
          }
        }
        .gangjuan {
          position: absolute;
          left: 0;
          width: 100%;
          height: 100%;

          // background-color: pink;
          .b1 {
            position: absolute;
            left: 0;
            top: 0;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: #fff;
            z-index: 3333;
          }
          .active {
            position: absolute;
            left: 0;
            top: 0;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: red;
          }
        }
        .tianche {
          height: 2px;
          width: 100%;
          background-color: rgb(60, 206, 243);
          position: absolute;
          top: 20px;
          left: 0;
          z-index: 4444;

          .circle1 {
            width: 10px;
            height: 20px;
            border-radius: 0px 10px 10px 0px;
            line-height: 10px;
            position: absolute;
            bottom: -10px;
            left: 0px;
            background-color: rgb(60, 206, 243);
          }
          .circle2 {
            width: 25px;
            height: 15px;
            background-color: rgb(248, 231, 76);
            position: absolute;
            top: -7.5px;
            border-radius: 5px;
          }
          .circle3 {
            width: 10px;
            height: 20px;
            border-radius: 10px 0px 0 10px;
            line-height: 10px;
            position: absolute;
            bottom: -10px;
            right: 0px;
            background-color: rgb(60, 206, 243);
          }
        }
      }
    }
  }
  el-popover {
    z-index: 22222 !important;
  }
  /deep/ .el-input--suffix .el-input__inner {
    padding-right: 50px;
  }
  /deep/.el-input__inner {
    color: #fff;
    background-color: #354165;
    border: none;
  }
  /*滚动条样式*/

  .chepaiList::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .chepaiList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px #fff;
    background: #fff;
  }
  .chepaiList::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  /*滚动条样式*/

  .divCenter::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .divCenter::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px #fff;
    background: #fff;
  }
  .divCenter::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
